import $ from 'jquery';
import './vendor/skip-link-focus-fix.js';
import slick from 'slick-carousel';
import 'magnific-popup/dist/jquery.magnific-popup';
import 'malihu-custom-scrollbar-plugin';
//import LazyLoad from "vanilla-lazyload/dist/lazyload.es2015.js";
import lozad from 'lozad/dist/lozad';
import 'jquery-mousewheel';
import 'select2/dist/js/select2.full.min';
import Cookies from 'js-cookie/src/js.cookie';


if (!$('.contact').length) {
  var resizeId,
    clock = $('.clock'),
    clockOffsetTop = clock.offset().top;
}

$(document).ready(function () {
  $(window).on("load", function () {
    $(".mfp-content").mCustomScrollbar();

    if ($('body').hasClass('home')) {
      virtualTourContactPopup();
    }
  });

  dropDownContact();
  succesMessage();

  residencesSlider();
  popupGallery();
  handleTextAnimation();
  toggleMainMenu();
  legalPopup();
  mapLink();
  if (!$('.contact').length) {
    fixedButtonOnScroll();
    imagesLightbox();
  }

  // var myLazyLoad = new LazyLoad({
  //     elements_selector: ".lazy",
  //     threshold: 500
  // });

  const el = document.querySelector('.lazy');
  const observer = lozad(); // passing a `NodeList` (e.g. `document.querySelectorAll()`) is also valid
  observer.observe();
});


$(window).resize(function () {
  clearTimeout(resizeId);
  resizeId = setTimeout(doneResizing, 500);
});

$(window).scroll(function (event) {
  fixedButtonOnScroll();
  handleTextAnimation();
});

function moveScreenReader() {
  if ($(window).width() < 990) {
    $('.sc-reader-detail').insertAfter('.footer-right');
  }
}
function doneResizing() {

}

function toggleMainMenu() {
  var nav = $('.navigation-wrapper'),
    open = $('.site-navigation-open'),
    close = $('.site-navigation-close'),
    body = $('body');
  $(open).on('click', function () {
    body.addClass('no-scroll');
    nav.slideDown();
    open.addClass('menu-active');
    close.addClass('visible');
    // if($.magnificPopup.instance.isOpen) {
    //   $.magnificPopup.close();
    // }
  });
  $(close).on('click', function () {
    body.removeClass('no-scroll');
    nav.slideUp();
    close.removeClass('visible');
    open.removeClass('menu-active');
  });
}

function legalPopup() {
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,
    modal: true,
    callbacks: {
      open: function () {
        $(".mfp-content #legal .text-wrapper").mCustomScrollbar();
        $('body').removeClass('scrollable');
      },
      close: function () {
        $('body').addClass('scrollable');
      }
    }
  });
  $(document).on('click', '.legal-close', function (e) {
    $.magnificPopup.close();
  });
  $(document).on('click', '.popup-modal', function () {
    if ($('.site-navigation-open').hasClass('menu-active')) {
      $('.site-navigation-close').click();
    }
  });
}

function fixedButtonOnScroll() {
  if (!$('.contact').length) {
    if ($(window).scrollTop() > clockOffsetTop - 100 + clock.height()) {
      clock.addClass('fixed');
    } else {
      clock.removeClass('fixed');
    }
  }
}

function imagesLightbox() {
  if ($('.section-image-link').length) {
    $('.section-image-link').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: false,
      mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
      image: {
        verticalFit: true
      },
      zoom: {
        enabled: true,
        duration: 300 // don't foget to change the duration also in CSS
      }
    });
  }
}

function handleTextAnimation() {
  var textElements = $('.animate-fade-bottom:not(.animate-fade-bottom--show)');

  textElements.each(function () {
    var elem = $(this);
    if (entersInView(elem)) {
      setTimeout(function () {
        elem.addClass('animate-fade-bottom--show');
      }, 400);
    }
  });
}

function entersInView(element) {
  var windowBottom = $(window).scrollTop() + $(window).outerHeight(),
    elementTop = element.offset().top - element.outerHeight() + parseInt(element.css('padding-top')) + 50;

  if (windowBottom > elementTop) {
    return true;
  }

  return false;
}

function mapLink() {
  var mapLink = $('.site-navigation .scroll-to-map a');
  if (mapLink.length) {
    var href = mapLink.attr('href');
    var hrefWithoutLastSlash = href.replace(/\/$/, "");
    mapLink.attr('href', hrefWithoutLastSlash + '#map');
  }
}

function residencesSlider() {
  $('.residences-slider img').click(function () {
    $('.page-template-residences .mfp-ready .mfp-figure').css("opacity", "0", "important");
  })

  var $carousel = $('.page-template-residences .residences-slider');
  if ($carousel.length) {
    $carousel
      .slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        dots: true,
        fade: true,
        cssEase: 'linear',
        autoplay: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: false
      })


      .magnificPopup({
        type: 'image',
        delegate: 'a:not(.slick-cloned)',
        closeOnContentClick: false,
        tLoading: 'loading...',
        mainClass: 'mfp-zoom-in mfp-img-mobile',
        image: {
          verticalFit: true,
        },
        gallery: {
          enabled: true,
          navigateByImgClick: false,
          tCounter: '<span class="mfp-counter">%curr% of %total%</span>', // markup of counte
          preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
        },
        zoom: {
          enabled: true,
          duration: 300
        },
        removalDelay: 300, //delay removal by X to allow out-animation
        callbacks: {
          open: function () {
            //overwrite default prev + next function. Add timeout for css3 crossfade animation
            $.magnificPopup.instance.next = function () {
              var self = this;
              self.wrap.removeClass('mfp-image-loaded');
              setTimeout(function () { $.magnificPopup.proto.next.call(self); }, 120);
            };
            $.magnificPopup.instance.prev = function () {
              var self = this;
              self.wrap.removeClass('mfp-image-loaded');
              setTimeout(function () { $.magnificPopup.proto.prev.call(self); }, 120);
            };
            var current = $carousel.slick('slickCurrentSlide');
            $carousel.magnificPopup('goTo', current);
          },
          imageLoadComplete: function () {
            var self = this;
            setTimeout(function () { self.wrap.addClass('mfp-image-loaded'); }, 16);
          },
          beforeClose: function () {
            $carousel.slick('slickGoTo', parseInt(this.index));
          }
        }
      });
  }

  $('.pause').on('click', function () {
    $carousel.slick('slickPause');
    $(this).css("display", "none");
    $('.play').css("display", "block");
  });

  $('.play').on('click', function () {
    $carousel.slick('slickPlay');
    $(this).css("display", "none");
    $('.pause').css("display", "block");
  });

  $('.residences-slider .slick-prev').insertBefore('.residences-slider .slick-dots li:first-child');
  $('.residences-slider .slick-next').insertAfter('.residences-slider .slick-dots li:last-child');
  $('.section-popup-gallery .buttons').insertBefore('.residences-slider .slick-dots');

  if ($('body').hasClass('page-template-model-residences')) {
    $carousel.slick('unslick');
    $('.residences-slider div:last-child img').addClass('last-img');
  }

}

function popupGallery() {
  var $popup = $('.page-template-model-residences .residences-slider');

  $popup.each(function () { // the containers for all your galleries shoudl ahve the class gallery
    $(this).magnificPopup({
      type: 'image',
      delegate: 'a:not(.slick-cloned)',
      closeOnContentClick: false,
      tLoading: 'loading...',
      mainClass: 'mfp-zoom-in mfp-img-mobile',
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return '<div class="popup-image-title">' + item.el.find('img').attr('caption') + '</div>';
        }
      },
      gallery: {
        enabled: true,
        navigateByImgClick: false,
        tCounter: '<span class="mfp-counter">%curr% of %total%</span>', // markup of counte
        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
      },
      zoom: {
        enabled: true,
        duration: 300
      },
      removalDelay: 300,
      callbacks: {
        open: function () {
          //overwrite default prev + next function. Add timeout for css3 crossfade animation
          $.magnificPopup.instance.next = function () {
            var self = this;
            self.wrap.removeClass('mfp-image-loaded');
            setTimeout(function () { $.magnificPopup.proto.next.call(self); }, 120);
          };
          $.magnificPopup.instance.prev = function () {
            var self = this;
            self.wrap.removeClass('mfp-image-loaded');
            setTimeout(function () { $.magnificPopup.proto.prev.call(self); }, 120);
          };
        },
        imageLoadComplete: function () {
          var self = this;
          setTimeout(function () { self.wrap.addClass('mfp-image-loaded'); }, 16);
        },
        beforeClose: function () {
          //  $carousel.slick('slickGoTo', parseInt(this.index));
        },
        elementParse: function (item) {
          console.log(item.el[0].className);
          if (item.el[0].className == 'video') {
            item.type = 'iframe',
              item.iframe = {
                patterns: {
                  youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                  },
                  vimeo: {
                    index: 'vimeo.com/',
                    id: '/',
                    src: '//player.vimeo.com/video/%id%?autoplay=1'
                  },
                  gmaps: {
                    index: '//maps.google.',
                    src: '%id%&output=embed'
                  }
                }
              }
          } else {
            item.type = 'image',
              item.tLoading = 'Loading image #%curr%...',
              item.mainClass = 'mfp-img-mobile',
              item.image = {
                tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
              }
          }

        }
      }

    });
  });
}

function virtualTourContactPopup() {

  //if (!localStorage.getItem('virtual-tour-popup-cookie')) {

  if (!Cookies.get('virtual-tour-popup-cookie') && $('#virtual-tour-popup-container').hasClass('show-popup')) {

    function openPopup() {
      var popupvirtualTour = $('#virtual-tour-popup-container');

      $.magnificPopup.open({
        items: {
          src: popupvirtualTour,
          type: 'inline'
        },
        callbacks: {
          open: function () {
            $('body').css('overflow', 'hidden');
          },
          close: function () {
            $('body').css('overflow', '');
          },
        },
        mainClass: 'mfp-fade',
        removalDelay: 200,
        showCloseBtn: true,
        fixedContentPos: true
      });

      //localStorage.setItem('virtual-tour-popup-cookie', 'true');
      Cookies.set('virtual-tour-popup-cookie', true, { expires: 1 });
    }
    setTimeout(openPopup, 5000);
  }
}

function dropDownContact() {

  // contactBlockScroll();
  conditionalSelect2();

  $('#residence-type').select2({
    dropdownCssClass: 'no-search',
    placeholder: 'DESIRED RESIDENCE',
  });
  $('#represented').select2({
    dropdownCssClass: 'no-search',
    placeholder: 'ARE YOU REPRESENTED BY A BROKER?*',
  });
  $('#broker').select2({
    dropdownCssClass: 'no-search',
    placeholder: 'ARE YOU A BROKER?*',
  });
  $('#price-type').select2({
    dropdownCssClass: 'no-search',
    placeholder: 'PRICE',
  });
  $('#hear-about').select2({
    dropdownCssClass: 'no-search',
    placeholder: 'HOW DID YOU HEAR ABOUT US?',
  });
  var formSize = $('.contact .form .wpcf7 .select2').width();
  console.log($('.no-search'));
  $('.no-search').css('width', formSize);
}


function contactBlockScroll() {
  if ($(window).width() > 1025) {
    $('body').css('overflow', 'hidden');
  }
}

function conditionalSelect2() {
  $('.other-source').parent().css('display', 'none');
  $('select[name="hear-about"]').on('select2:select', function (e) {
    var selection = $('select[name="hear-about"]').select2('data')[0].id;
    if (selection == "OTHER") {
      $('.other-source').parent().css('display', 'block');
    } else {
      $('.other-source').parent().css('display', 'none');
    }
  });

  $('.broker-email').parent().css('display', 'none');
  $('select[name="represented"]').on('select2:select', function (e) {
    var selection = $('select[name="represented"]').select2('data')[0].id;
    if (selection == "Yes") {
      $('.broker-email').parent().css('display', 'block');
    } else {
      $('.broker-email').parent().css('display', 'none');
    }
  });
}

function succesMessage() {
  document.addEventListener('wpcf7mailsent', function (event) {
    $('.home .virtual-tour-popup-content div').addClass('not-visible');
    $('.home .thank-you-sent').addClass('visible');
  }, false);
}
